import React, { useEffect } from 'react';
import useToolStore, { TOOL_TYPES } from '../../../store/useToolStore';
import { generateCode } from '../../../utils/codeGenerators';
import JsonToModelPreview from './JsonToModelPreview';
import JsonToModelControls from './JsonToModelControls';

const JsonToModelGenerator = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.JSON_TO_MODEL]);
  const updateConfig = useToolStore((state) => state.updateToolConfig);
  const setGeneratedCode = useToolStore((state) => state.setGeneratedCode);

  useEffect(() => {
    const code = generateCode(TOOL_TYPES.JSON_TO_MODEL, config);
    setGeneratedCode(code);
  }, [config, setGeneratedCode]);

  const handleConfigChange = (newConfig) => {
    updateConfig(TOOL_TYPES.JSON_TO_MODEL, newConfig);
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">JSON to Codable Generator</h2>
      <JsonToModelControls config={config} onChange={handleConfigChange} />
    </div>
  );
};

export const JsonToModelPreviewComponent = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.JSON_TO_MODEL]);
  return <JsonToModelPreview config={config} />;
};

export default JsonToModelGenerator;

